import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-forget-password',
  templateUrl: './dialog-forget-password.component.html',
  styleUrls: ['./dialog-forget-password.component.css']
})

export class DialogForgetPasswordComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
